import React, { createContext, useContext } from 'react';
import { ActionPromptType, usePrompts } from '../hooks/prompts';
import { useDispatch } from '../hooks';
import { completeActionPrompt } from '../redux/action-prompts/complete-action-prompt.handler';

type PromptsContextType = {
    hasPrompt: (prompt: ActionPromptType) => boolean;
    completePrompt: (prompt: ActionPromptType) => void;
};

const PromptsContext = createContext<PromptsContextType>({
    hasPrompt: () => false,
    completePrompt: () => {},
});

export const PromptsProvider: React.FC<{children: React.ReactNode}> = ({ children }) => {
    const { removePrompt, hasPrompt } = usePrompts();
    const dispatch = useDispatch();

    const completePrompt = (prompt: ActionPromptType) => {
        if (prompt > ActionPromptType.ADDITIONAL_RANGE)
            return;

        removePrompt(prompt);
        dispatch(completeActionPrompt());
    };
    
    return (
        <PromptsContext.Provider value={{ hasPrompt, completePrompt }}>
            {children}
        </PromptsContext.Provider>
    );
};

export const usePromptsContext = () => useContext(PromptsContext);